/* @flow */
import * as React from 'react';

import { Box } from '@sonyged/proc-ui';
import { ProcModal, Button, Footer } from '@sonyged/ext-proc';
import css from '@styled-system/css';
import styled from 'styled-components';

import { Pizza } from '../../../pizza/fields/domain/pizza';
import { YesterdayPizzaPanel } from '../YesterdayPizzaPanel';

type Props = {
  isOpen: boolean,
  pizza: Pizza,
  sale: number,
  star: number,
  onClose: Function,
};

export function YesterdayPizzaModal(props: Props) {
  let { isOpen, pizza, sale, star, onClose } = props;

  return (
    <ProcModal isOpened={isOpen} rootNodeId="proc-pizza-fields-root-page">
      <div key="modal" className={'proc-modal proc-modal--hint'}>
        <div className="proc-modal-container">
          <div className={'proc-modal-header'}>{'昨日のピザ'}</div>
          <Contents>
            <YesterdayPizzaPanel pizza={pizza} sale={sale} star={star} />
          </Contents>
        </div>
        <Footer.normal shadow={false}>
          <Button.attention onClick={onClose}>とじる</Button.attention>
        </Footer.normal>
      </div>
    </ProcModal>
  );
}

const Contents = styled(Box)(
  css({
    flex: 1,
    minHeight: 0,
    px: [16, 16, 0], // because proc-modal--hint
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  })
);
